module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/jquery-i18next/index.js
// module id = 281
// module chunks = 0